import React, { FC } from 'react';
import { CompactMoneyProps, CompactMoney } from '@websky/core/src/Money';
import { Currency } from '@websky/core/src/enums';

/**
 * В рамках задачи WEBSKY-6920, просили убрать иконку валюты и скоращение
 */
export const SearchFormDatepickerCompactMoney: FC<CompactMoneyProps> = props => {
	const amountRenderer = (amount: number, currency: string | Currency, limit: number) => Math.round(amount);

	return <CompactMoney {...props} compactAmountRenderer={amountRenderer} />;
};
